import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import gerador from "../../Assets/Projects/gerador.png";
import login from "../../Assets/Projects/login.png";
import conversor from "../../Assets/Projects/conversor.png";
import pizzaria from "../../Assets/Projects/pizzaria.png";
import cafe from "../../Assets/Projects/cafe.png";
import mentalista from "../../Assets/Projects/mentalista.png";
import fruta from "../../Assets/Projects/fruta.PNG";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Meus <strong className="purple">projetos </strong>
        </h1>
        <p style={{ color: "white" }}>
          Aqui você encontra alguns dos meus projetos recentes.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pizzaria}
              isBlog={true}
              title="Pizzaria Hungry"
              description="Página responsiva feita com HTML e CSS. Trata-se de um projeto inicial para uma pizzaria fictícia. Por isso, ele contém alguns itens de destaque, como menu, blog, endereço, entre outros detalhes."
              link="https://web-pizzaria.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mentalista}
              isBlog={true}
              title="O Mentalista"
              description="Jogo feito com HTML, CSS e Javascript durante a Imersão Alura. O objetivo é testar se a pessoa acerta ou não o número (de 0 a 10) que foi escolhido pelo site."
              link="https://mentalista-teal.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={conversor}
              isBlog={true}
              title="Conversor de moeda"
              description="Site desenvolvido durante a Imersão Alura, utilizando HTML, CSS e Javascript. O objetivo é facilitar a vida das pessoas que querem desejam saber quanto o dólar canadense está valendo em reais."
              link="https://conversor-moeda-canada.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gerador}
              isBlog={true}
              title="Gerador de frase do dia"
              description="Gerador de frase responsivo feito com HTML, CSS e Javascript que traz mensagens motivacionais para o seu dia. O projeto foi feito durante a Imersão Alura."
              link="https://gerador-frase-dia.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cafe}
              isBlog={true}
              title="Quadrado Coffee House"
              description="Página inicial de casa de café fictícia feita com HTML e CSS. O intuito foi elaborar uma página clean e moderna para trazer novos clientes interessados pelos sabores de café inovadores dessa casa."
              link="https://quadrado-cafe.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={login}
              isBlog={true}
              title="Login para grupo Dev"
              description="Projeto feito com HTML e CSS. O objetivo foi desenvolver uma página de login responsiva que pudesse receber logins diversos para entrar em um grupo exclusivo de desenvolvedores."
              link="https://login-tema-dark.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fruta}
              isBlog={true}
              title="Landing page Fruta & Fruto"
              description="Projeto de landing page feito com Bootstrap durante um curso especial da Alura. A intenção foi trazer um visual leve e bonito para expor as receitas."
              link="https://landing-page-frutas.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
